module.exports = __webpack_public_path__ + "static/media/OW.6f983204.jpg";